///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getFeatureFlag } from "../api/api";
import types from "../helpers/types";

export const initialState = {};

for (let featureFlagName in types.featureFlags) {
  initialState[types.featureFlags[featureFlagName]] = {
    requestStatus: types.requestStatuses.initial,
    value: false,
  };
}

const featureFlagsSlice = createSlice({
  name: "featureFlagsSlice",
  initialState,
  reducers: {
    requestFeatureFlag: (state, { payload }) => {
      state[payload].requestStatus = types.requestStatuses.inProgress;
    },
    receiveFeatureFlagSuccess: (state, { payload }) => {
      const [featureFlagName, featureFlagValue] = payload;
      state[featureFlagName].requestStatus = types.requestStatuses.success;
      state[featureFlagName].value = featureFlagValue;
    },
    receiveFeatureFlagFailure: (state, { payload }) => {
      state[payload].requestStatus = types.requestStatuses.failure;
      state[payload].value = false;
    },
  },
});

export const {
  requestFeatureFlag,
  receiveFeatureFlagSuccess,
  receiveFeatureFlagFailure,
} = featureFlagsSlice.actions;

export const fetchFeatureFlag = (featureFlagName) => async (dispatch) => {
  let featureFlagValue;
  dispatch(requestFeatureFlag(featureFlagName));
  try {
    featureFlagValue = await getFeatureFlag(featureFlagName);
  } catch (e) {
    dispatch(receiveFeatureFlagFailure(featureFlagName));
    return;
  }
  dispatch(receiveFeatureFlagSuccess([featureFlagName, featureFlagValue]));
};

export const featureFlagsReducer = featureFlagsSlice.reducer;
